import React, { type MouseEvent } from 'react'
import { usePage } from 'src/hooks/usePage'
import { SECTIONS, type SectionType } from 'src/hooks/useKafkaEvent/constants'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'

interface DatesChangeConnectedProps {
  children: React.ReactElement<React.ReactNode>
  trackingData: {
    context: string
    details: string
  }
}

type SendChangeDatesPeopleType = (
  section: { section: SectionType },
  payload: { context: string; details: string }
) => void

export const handleClick = (
  mouseEvent: MouseEvent<HTMLDivElement>,
  children: React.ReactElement,
  sendChangeDatesPeople: SendChangeDatesPeopleType,
  context: string,
  details: string
) => {
  sendChangeDatesPeople(
    { section: SECTIONS.CHANGE_PAXES_DATES },
    {
      context,
      details,
    }
  )

  if (children.props.onClick) {
    children.props.onClick(mouseEvent)
  }
}

const DatesChangeConnected: React.FC<DatesChangeConnectedProps> = ({ trackingData, children }) => {
  const { pageId } = usePage()
  const { context, details } = trackingData || {}

  const { sendEvent: sendChangeDatesPeople } = useKafkaEvent({
    eventName: 'change_dates_people',
    eventType: 'impression',
    page: pageId,
  })

  const handleClickBound = (mouseEvent: MouseEvent<HTMLDivElement>) =>
    handleClick(mouseEvent, children, sendChangeDatesPeople, context, details)

  return React.cloneElement(children, {
    ...(children as any).props,
    onClick: handleClickBound,
  })
}

export default DatesChangeConnected
